import cx from 'classnames';

import { Box, Divider, Skeleton } from '@flixbus/honeycomb-react';

import styles from './styles.module.css';

const LoadingInfo = ({ loading, error }) => {
	if (!loading && !error) return null;

	return (
		<>
			<Box extraClasses={styles.block}>
				<div className={styles.blockItem}>
					<Skeleton inline round width="md" height="md" />
					<Skeleton inline round width="md" height="md" />
					<Skeleton Elem="div" height="sm" />
					<Skeleton Elem="div" height="sm" />
				</div>

				<Divider />

				<div className={cx(styles.blockItem, styles.block)}>
					<Skeleton inline round width="md" height="md" />
					<Skeleton Elem="div" height="sm" />
				</div>
			</Box>

			<Box extraClasses={styles.block}>
				<div className={cx(styles.blockItem, styles.block)}>
					<Skeleton inline round width="md" height="md" />
					<Skeleton Elem="div" height="sm" />
				</div>

				<Divider />

				<div className={cx(styles.blockItem, styles.block)}>
					<Skeleton inline round width="md" height="md" />
					<Skeleton Elem="div" height="sm" />
				</div>
			</Box>

			<Box extraClasses={styles.block}>
				<div className={styles.blockItem}>
					<Skeleton inline round width="md" height="md" />
					<Skeleton Elem="div" height="sm" />
					<Skeleton Elem="div" height="sm" />
				</div>

				<Divider />

				<div className={cx(styles.blockItem, styles.block)}>
					<Skeleton inline round width="md" height="md" />
					<Skeleton Elem="div" height="sm" />
				</div>
			</Box>
		</>
	);
};

export default LoadingInfo;
